export const ULTRA_PLUS_FIELDS = [
  { key: "metaWhaleReferralLink", label: "T&S Referral Link" },
  { key: "metaWhaleReceivingAddress", label: "T&S Receiving Address" },
  { key: "metaWhaleUplinerLink", label: "T&S Upliner Link" },
  { key: "metaWhaleUplinerReceivedAddress", label: "T&S Upliner Received Address" },
  { key: "vBoostReferralLink", label: "V-Boost Referral Link" },
  { key: "vBoostReceivingAddress", label: "V-Boost Receiving Address" },
  { key: "vBoostUplinerLink", label: "V-Boost Upliner Link" },
  { key: "vBoostUplinerReceivedAddress", label: "V-Boost Upliner Received Address" },
];

export const ULTRA_PLUS_TS_FIELDS = ULTRA_PLUS_FIELDS.slice(0, 4);
export const ULTRA_PLUS_VBOOST_FIELDS = ULTRA_PLUS_FIELDS.slice(4);
export const ULTRA_PLUS_TS_WALLET_AMOUNT = 1000;
export const ULTRA_PLUS_VBOOST_WALLET_AMOUNT = 1100;

/** Must be unique across all users (upliner fields may duplicate). */
export const ULTRA_PLUS_UNIQUE_FIELDS = [
  { key: "metaWhaleReferralLink", label: "T&S Referral Link" },
  { key: "metaWhaleReceivingAddress", label: "T&S Receiving Address" },
  { key: "vBoostReferralLink", label: "V-Boost Referral Link" },
  { key: "vBoostReceivingAddress", label: "V-Boost Receiving Address" },
];

export const ULTRA_PLUS_UNIQUE_FIELD_KEYS = ULTRA_PLUS_UNIQUE_FIELDS.map(
  (f) => f.key
);

export function normalizeUltraPlusUniqueValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export const getUltraPlusFieldValues = (source = {}) =>
  ULTRA_PLUS_FIELDS.reduce((acc, { key }) => {
    acc[key] = (source[key] || "").trim();
    return acc;
  }, {});

export const hasAllUltraPlusFields = (source = {}) =>
  ULTRA_PLUS_FIELDS.every(({ key }) => (source[key] || "").trim().length > 0);

export const getUltraPlusFieldLabels = (fieldKeys = []) =>
  ULTRA_PLUS_FIELDS.filter(({ key }) => fieldKeys.includes(key)).map(
    ({ label }) => label
  );

export const formatUltraPlusFieldList = (fieldKeys = []) => {
  const labels = getUltraPlusFieldLabels(fieldKeys);
  if (labels.length === 0) return "None";
  return labels.map((label) => `- ${label}`).join("\n");
};
